export default "__VITE_ASSET__DGb_9SWp__"